import { v4 as uuidv4 } from 'uuid';

export default {
    getCompanyById(id, params) {
        return ApiClient.get(`/companies/${id}`, params);
    },
    getCompanies(params, filters) {
        return ApiClient.post('/companies/search', params, { filters });
    },
    getCompanyContact(id) {
        return ApiClient.get(`/companies/${id}/contacts`);
    },
    getCompaniesBySearchScan(params) {
        return ApiClient.get('/companies/scan/search', params);
    },
    getCompanyBySearchScan(id, params) {
        return ApiClient.get(`/companies/scan/${id}`, params);
    },
    createCompany(data) {
        const customFields = data.customFields.map((customField) => {
            return {
                id: customField.id,
                value: customField.value,
            };
        });

        const validAddress = Object.values(data.address).some((value) => !!value);

        const companyUuid = uuidv4();

        const batchRequest = [
            {
                uri: '/companies',
                method: 'POST',
                uuid: companyUuid,
            },
            {
                name: data.name,
                type: data.type,
                legal_france: {
                    siret: data.siret || null,
                },
            },
        ];

        if (validAddress) {
            batchRequest.push(
                {
                    uri: `/companies/${companyUuid}/addresses`,
                    method: 'POST',
                    uuid: uuidv4(),
                },
                {
                    name: data.address.label,
                    address_line_1: data.address.line1,
                    address_line_2: data.address.line2,
                    postal_code: data.address.postalCode,
                    city: data.address.city,
                    country: data.address.country,
                    country_code: data.address.country,
                },
            );
        }

        if (customFields.length) {
            batchRequest.push({
                uri: `/companies/${companyUuid}/custom-fields`,
                method: 'PUT',
                uuid: uuidv4(),
            });

            batchRequest.push(customFields);
        }
        return ApiBatchClient.post('/batch', {}, batchRequest.map(JSON.stringify).join('\n'));
    },

    deleteCompany(id) {
        return ApiClient.del(`/companies/${id}`);
    },

    getCompanyAddresses(id) {
        return ApiClient.get(`/companies/${id}/addresses`);
    },

    async getAllCompanyAddresses(id) {
        let data = [];
        let pagination = { offset: '', total: 0 };

        do {
            const response = (
                await ApiClient.get(`/companies/${id}/addresses`, { offset: pagination.offset })
            ).data;
            pagination = response?.pagination ?? pagination;
            data = data.concat(response?.data ?? []);
        } while (data.length < pagination.total);
        return data;
    },

    updateCompany(id, params = {}, data) {
        return ApiClient.put(`/companies/${id}`, params, data);
    },
    createCompanyAddress(id, address) {
        return ApiClient.post(`/companies/${id}/addresses`, {}, address);
    },
    updateCompanyAddress(id, address) {
        return ApiClient.put(`/companies/${id}/addresses/${address.id}`, {}, address);
    },
};
